var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0323 8.11427C11.2748 8.31427 11.2748 8.68574 11.0323 8.88573L7.06814 12.1553C6.74202 12.4243 6.25 12.1923 6.25 11.7696L6.25 5.23039C6.25 4.80766 6.74202 4.57569 7.06814 4.84467L11.0323 8.11427Z",
    fill: "#4050A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBlue);
export default __webpack_public_path__ + "static/media/open_blue.d27fa4aaa3c39ff21540925eeccfc6db.svg";
export { ForwardRef as ReactComponent };